import GmailIcon from '@/components/Icons/icons/gmailLogo.svg';
import outlookLogo from '@/components/Icons/icons/outlookLogo.svg';

import { OAUTH_SETUP_DOC, OUTLOOK_SETUP_DOC } from '../constants';

export const EMAIL_CONNECTION_STATUS_QUERY_PARAM = {
  EMAIL_CONNECTION_STATUS: 'email_connection_success',
  EMAIL_ADDRESS: 'email_address',
  FAILURE_REASON: 'failure_reason',
};

export const EMAIL_CONNECTION_FAILURE_REASONS = {
  EMAIL_NOT_FOUND: 'EMAIL_NOT_FOUND',
  GENERIC: 'GENERIC',
  EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
  SL_FAILED: 'SL_FAILED',
};

export const EMAIL_CONNECTION_MODALS_ENUM = {
  CONNECT_EMAIL: 'CONNECT_EMAIL',
  ENABLE_GMAIL_2FA: 'ENABLE_GMAIL_2FA',
  CREATE_APP_PASSWORD: 'CREATE_APP_PASSWORD',
  EMAIL_CONNECTION: 'EMAIL_CONNECTION',
  CONNECTION_RESULT: 'CONNECTION_RESULT',
  ADMIN_IDENTITY_VERIFICATION: 'ADMIN_IDENTITY_VERIFICATION',
  ADMIN_ACCESS_NEEDED_VIDEO_TUT: 'ADMIN_ACCESS_NEEDED_VIDEO_TUT',
  OAUTH_SETUP: 'OAUTH_SETUP',
  OAUTH_SETUP_SUCCESS: 'OAUTH_SETUP_SUCCESS',
  ADMIN_ACCESS_NEEDED: 'ADMIN_ACCESS_NEEDED',
  SEND_INSTRUCTIONS: 'SEND_INSTRUCTIONS',
  ACCESS_GRANTED: 'ACCESS_GRANTED',
  SELECT_EMAIL_PROVIDER: 'SELECT_EMAIL_PROVIDER',
  SEE_CONNECTION_STEPS: 'SEE_CONNECTION_STEPS',
  DELETE_EMAIL_WARNING: 'DELETE_EMAIL_WARNING',
};

export const EMAIL_PROVIDERS = {
  GMAIL: 'gmail',
  OUTLOOK: 'outlook',
};

export const EMAIL_PROVIDERS_DATA = [
  {
    name: 'Gmail',
    logo: GmailIcon,
    value: EMAIL_PROVIDERS.GMAIL,
    className: 'gmail-icon',
    documentLink: OAUTH_SETUP_DOC,
  },
  {
    name: 'Outlook',
    logo: outlookLogo,
    value: EMAIL_PROVIDERS.OUTLOOK,
    className: 'outlook-icon',
    documentLink: OUTLOOK_SETUP_DOC,
  },
];

export const TWO_FA_DATA = [
  '<p>Go to your Google Account&apos;s <strong><a href="https://myaccount.google.com/u/0/security" target="_blank" >Security Settings</a></strong></p>',
  '<p>Enable <strong><a href="https://myaccount.google.com/u/0/signinoptions/twosv" target="_blank" >2-step verifications</a></strong> by verifying your phone number</p>',
];

export const CREATE_APP_PASSWORD_DATA = [
  '<p>From your Google Account&apos;s  <strong><a href="https://myaccount.google.com/u/0/security" target="_blank" >Security Settings</a></strong>, Create an <strong><a href="https://myaccount.google.com/u/0/apppasswords" target="_blank" >App password.</a></strong>.</p>',
  '<p>Select <strong>“Other”</strong> for both App & Device and type a random name</p>',
  '<p>Click on the <strong>“Generate”</strong> button.</p>',
];

export const EMAIL_CONNECTION_REDIRECTION_LINK = {
  APP_PASSWORD: 'https://myaccount.google.com/u/0/apppasswords',
};
